const api = {
  underwriterListByMajorCompanyCode(code) {
    return `/underwriters/search/majorcompany=${code}`;
  },
  allUnderWritersForCurrentUser() {
    return `/underwriters/search`;
  },
  allActiveUnderWritersForCurrentUser() {
    return `/underwriters/active`;
  },
  assignCases() {
    return `/underwriters/assignment`;
  },
  getNext() {
    return `/underwriters/review-case`;
  },
  getUnderwriters(internetUserId) {
    return `/underwriters/users/${internetUserId}`;
  },
  getAuthorizedUnderwriters(internetUserId) {
    return `/underwriters/users/${internetUserId}/authorized`;
  },
  addInternetUser(underwriterId, internetUserId) {
    return `/underwriters/${underwriterId}/users/${internetUserId}`;
  },
  removeInternetUser(underwriterId) {
    return `/underwriters/${underwriterId}/user`;
  },
  updateUnderwriter(underwriterId) {
    return `/underwriters/${underwriterId}/`;
  }
};

export default api;